const profileBioModal = (state) => state.modals.profile.bio;

// eslint-disable-next-line import/prefer-default-export
export { profileBioModal };
